var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{attrs:{"id":_vm.id,"rows":_vm.rows},domProps:{"value":_vm.item[_vm.property]},on:{"input":function($event){return _vm.$emit('fieldUpdated', _vm.property, $event.target.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }